import StatCard from '../common/StatCard';
import { Icon } from '../common/Icon';

// StatCard expects a react-icons component; adapt the app's semantic Icon
// names to that contract once, here.
const named = (name) => function NamedIcon(props) { return <Icon name={name} {...props} />; };
const ICONS = {
  success: named('success'),
  due: named('due'),
  critical: named('critical'),
  money: named('money'),
  company: named('company'),
};

// Sub-line with the little status dot the dashboard KPIs carry.
const DotSub = ({ color, children }) => (
  <span className="inline-flex items-center gap-1.5">
    <span className="text-[8px]" style={{ color }}>●</span>
    <span>{children}</span>
  </span>
);

/**
 * KpiGrid — the dashboard's five compliance KPIs, on the shared StatCard
 * primitive. Pure presentation: every number arrives computed from
 * useDashboard()/companies in the page.
 */
export default function KpiGrid({ fullyCompliant, compliantPct, dueThisMonth, overdueCritical, penaltyDisplay, totalPenalty, totalCompanies }) {
  const penaltyTone = totalPenalty > 0 ? '#9a564a' : '#4a6b3f';
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 mb-3.5">
      <StatCard compact icon={ICONS.success} tone="#4a6b3f" label="Fully Compliant" value={fullyCompliant} sub={<DotSub color="#4a6b3f">{compliantPct}% of portfolio</DotSub>} />
      <StatCard compact icon={ICONS.due} tone="#8a6a1f" label="Due This Month" value={dueThisMonth} sub={<DotSub color="#8a6a1f">Action required</DotSub>} />
      <StatCard compact icon={ICONS.critical} tone="#9a564a" label="Overdue / Critical" value={overdueCritical} sub={<DotSub color="#9a564a">Immediate attention</DotSub>} />
      <StatCard compact icon={ICONS.money} tone={penaltyTone} label="Penalty Exposure" value={penaltyDisplay} sub={<DotSub color={penaltyTone}>{totalPenalty > 0 ? 'If unaddressed' : 'All clear'}</DotSub>} />
      <StatCard compact icon={ICONS.company} tone="#3a4a66" label="Total Companies" value={totalCompanies} sub={<DotSub color="#3a4a66">Pvt · LLP · OPC · Pub</DotSub>} />
    </div>
  );
}
